<template>
  <div class="table_container">
    <div class="table-btn" style="margin: 24px 0 12px 0">
      <el-button
        v-if="$route.query.operateType !== '查看'"
        :disabled="tableData.length >= 15"
        type="primary"
        size="small"
        @click="handleAdd()"
        >添加</el-button
      >
    </div>
    <el-table
      ref="tableRef"
      highlight-current-row
      :border="true"
      :data="tableData"
      :header-cell-style="{
        background: '#EFEFEF',
        color: '#000',
        borderColor: '#dcdfe6'
      }"
      :cell-class-name="cellClassName"
      @cell-click="handleCellClick"
    >
      <!-- 序号 -->
      <el-table-column label="序号" width="50px" align="center">
        <template slot-scope="scope">
          {{ scope.$index + 1 }}
        </template>
      </el-table-column>
      <!-- 汽车品牌 -->
      <el-table-column
        prop="carBrand"
        label="汽车品牌"
        min-width="90px"
        align="center"
      >
        <template slot-scope="scope">
          <el-input
            v-if="editField === 'carBrand' && editIndex === scope.$index"
            id="focusRef"
            v-model="scope.row.carBrand"
            size="mini"
            style="width: 100%"
            @blur="confirmEdit"
            @keyup.enter.native="confirmEdit"
          ></el-input>
          <div v-else>
            {{ scope.row.carBrand }}
          </div>
        </template>
      </el-table-column>
      <!-- 合作伙伴 -->
      <el-table-column
        prop="partnershipPartner"
        label="合作伙伴"
        min-width="90px"
        align="center"
      >
        <template slot-scope="scope">
          <el-input
            v-if="
              editField === 'partnershipPartner' && editIndex === scope.$index
            "
            id="focusRef"
            v-model="scope.row.partnershipPartner"
            size="mini"
            style="width: 100%"
            @blur="confirmEdit"
            @keyup.enter.native="confirmEdit"
          ></el-input>
          <div v-else>
            {{ scope.row.partnershipPartner }}
          </div>
        </template>
      </el-table-column>
      <!-- 合作伙伴性质 -->
      <el-table-column
        prop="partnershipPartnerNature"
        label="合作伙伴性质"
        min-width="90px"
        align="center"
      >
        <template slot-scope="scope">
          <el-select
            v-if="
              editField === 'partnershipPartnerNature' &&
                editIndex === scope.$index
            "
            id="focusRef"
            v-model="scope.row.partnershipPartnerNature"
            placeholder="请选择"
            filterable
            clearable
            size="mini"
            automatic-dropdown
            @visible-change="visibleChange"
            @change="confirmEdit"
          >
            <el-option label="国营" value="国营"></el-option>
            <el-option label="私营" value="私营"></el-option>
          </el-select>
          <div v-else>
            {{ scope.row.partnershipPartnerNature }}
          </div>
        </template>
      </el-table-column>
      <!-- 合作模式 -->
      <el-table-column
        prop="cooperationModel"
        label="合作模式"
        min-width="90px"
        align="center"
      >
        <template slot-scope="scope">
          <el-input
            v-if="
              editField === 'cooperationModel' && editIndex === scope.$index
            "
            id="focusRef"
            v-model="scope.row.cooperationModel"
            size="mini"
            style="width: 100%"
            @blur="confirmEdit"
            @keyup.enter.native="confirmEdit"
          ></el-input>
          <div v-else>
            {{ scope.row.cooperationModel }}
          </div>
        </template>
      </el-table-column>
      <!-- 生产供应模式 -->
      <el-table-column
        prop="productionSupplyMode"
        label="生产供应模式"
        min-width="90px"
        align="center"
      >
        <template slot-scope="scope">
          <el-select
            v-if="
              editField === 'productionSupplyMode' && editIndex === scope.$index
            "
            id="focusRef"
            v-model="scope.row.productionSupplyMode"
            placeholder="请选择"
            filterable
            clearable
            size="mini"
            automatic-dropdown
            @visible-change="visibleChange"
            @change="confirmEdit"
          >
            <el-option label="CBU" value="CBU"></el-option>
            <el-option label="SKD" value="SKD"></el-option>
            <el-option label="CKD" value="CKD"></el-option>
          </el-select>
          <div v-else>
            {{ scope.row.productionSupplyMode }}
          </div>
        </template>
      </el-table-column>
      <!-- 销售模式 -->
      <el-table-column
        prop="saleMode"
        label="销售模式"
        min-width="90px"
        align="center"
      >
        <template slot-scope="scope">
          <el-select
            v-if="editField === 'saleMode' && editIndex === scope.$index"
            id="focusRef"
            v-model="scope.row.saleMode"
            placeholder="请选择"
            filterable
            clearable
            size="mini"
            automatic-dropdown
            @visible-change="visibleChange"
            @change="confirmEdit"
          >
            <el-option label="直营" value="直营"></el-option>
            <el-option label="分销" value="分销"></el-option>
            <el-option label="混合" value="混合"></el-option>
          </el-select>
          <div v-else>
            {{ scope.row.saleMode }}
          </div>
        </template>
      </el-table-column>
      <!-- 三级毛利水平 (%) -->
      <el-table-column label="三级毛利水平 (%)" align="center">
        <!-- KD -->
        <el-table-column prop="kd" label="KD" min-width="90px" align="center">
          <template slot-scope="scope">
            <el-input
              v-if="editField === 'kd' && editIndex === scope.$index"
              id="focusRef"
              v-model="scope.row.kd"
              size="mini"
              style="width: 100%"
              @blur="confirmEdit"
              @keyup.enter.native="confirmEdit"
            ></el-input>
            <div v-else>
              {{ scope.row.kd }}
            </div>
          </template>
        </el-table-column>
        <!-- 总代 -->
        <el-table-column
          prop="totalGeneration"
          label="总代"
          min-width="90px"
          align="center"
        >
          <template slot-scope="scope">
            <el-input
              v-if="
                editField === 'totalGeneration' && editIndex === scope.$index
              "
              id="focusRef"
              v-model="scope.row.totalGeneration"
              size="mini"
              style="width: 100%"
              @blur="confirmEdit"
              @keyup.enter.native="confirmEdit"
            ></el-input>
            <div v-else>
              {{ scope.row.totalGeneration }}
            </div>
          </template>
        </el-table-column>
        <!-- 终端 -->
        <el-table-column
          prop="terminal"
          label="终端"
          min-width="90px"
          align="center"
        >
          <template slot-scope="scope">
            <el-input
              v-if="editField === 'terminal' && editIndex === scope.$index"
              id="focusRef"
              v-model="scope.row.terminal"
              size="mini"
              style="width: 100%"
              @blur="confirmEdit"
              @keyup.enter.native="confirmEdit"
            ></el-input>
            <div v-else>
              {{ scope.row.terminal }}
            </div>
          </template>
        </el-table-column>
      </el-table-column>
      <!-- 备注 -->
      <el-table-column
        prop="remark"
        label="备注"
        min-width="90px"
        align="center"
      >
        <template slot-scope="scope">
          <el-input
            v-if="editField === 'remark' && editIndex === scope.$index"
            id="focusRef"
            v-model="scope.row.remark"
            size="mini"
            style="width: 100%"
            @blur="confirmEdit"
            @keyup.enter.native="confirmEdit"
          ></el-input>
          <div v-else>
            {{ scope.row.remark }}
          </div>
        </template>
      </el-table-column>
      <!-- 操作 -->
      <el-table-column
        v-if="$route.query.operateType !== '查看'"
        label="操作"
        align="center"
        width="90px"
        fixed="right"
      >
        <template slot-scope="scope">
          <!-- 删除 -->
          <el-button size="mini" type="text" @click="handleDelete(scope.$index)"
            >删除</el-button
          >
        </template>
      </el-table-column>
    </el-table>
  </div>
</template>

<script>
import { addOrUpdateProductionSaleModelApi } from "@/api/saleTaskCollection";

export default {
  data() {
    return {
      tableData: [],
      editField: "", // 编辑单元格
      editIndex: -1 // 编辑行索引
    };
  },
  methods: {
    init(data) {
      this.tableData = data || [];
    },
    // 添加
    handleAdd() {
      this.tableData.push({
        carBrand: "",
        partnershipPartner: "",
        partnershipPartnerNature: "",
        cooperationModel: "",
        productionSupplyMode: "",
        saleMode: "",
        kd: "",
        totalGeneration: "",
        terminal: "",
        remark: ""
      });
    },
    // 删除
    handleDelete(index) {
      this.tableData.splice(index, 1);
    },
    // 获取单元格索引
    cellClassName({ row, column, rowIndex, columnIndex }) {
      row.index = rowIndex;
      column = { ...column, index: columnIndex };
    },
    // 点击单元格
    handleCellClick(row, column) {
      this.handleColumn(column.property, row.index ?? -1);
      this.tableData[row.index][column.property] =
        this.tableData[row.index][column.property] ?? undefined;
    },
    // 点击单元格编辑
    handleColumn(field, index) {
      if (this.$route.query.operateType === "查看") return;
      this.editField = field;
      this.editIndex = index ?? -1;
      this.$nextTick(() => {
        document.querySelector("#focusRef")?.focus();
        document.querySelector("#focusRef .el-input__inner")?.focus();
      });
    },
    // 确认编辑
    confirmEdit() {
      this.editField = "";
      this.editIndex = -1;
    },
    // el-select 显示隐藏选项框时触发
    visibleChange(visible) {
      if (!visible) {
        this.confirmEdit();
      }
    },
    // 保存
    async handleSave(params) {
      try {
        const submitData = {
          ...params,
          dataList: JSON.parse(JSON.stringify(this.tableData))
        };
        const res = await addOrUpdateProductionSaleModelApi(submitData);
        if (res.status == 0) {
          this.$DonMessage.success("操作成功！");
          this.tableData = res.data;
        } else {
          this.$DonMessage.error(res.message);
        }
      } catch (error) {
        console.error(error);
      }
    }
  }
};
</script>

<style lang="scss" scoped>
.table_container {
  padding: 15px 18px 0 50px;
  .number_input {
    width: 100%;
    padding: 0;
    ::v-deep .el-input__inner {
      padding: 0 8px;
    }
  }
}
</style>
